export type ScheduledAssetPage = { key: string; memoryMiB?: number; eligible: boolean };

export function assetPageMemoryMiB(value: number | undefined): number {
    return Number.isFinite(value) && value! > 0 ? value! : 0.6;
}

/** Metadata alone defines the prefix. Preserve the first page crossing the cap. */
export function planAssetPageSchedule(pages: ScheduledAssetPage[], limitMiB: number) {
    const pageKeys = new Set<string>();
    let memoryMiB = 0;
    let memoryLimitReached = false;
    for (const page of pages) {
        if (!page.eligible || pageKeys.has(page.key)) continue;
        if (memoryMiB > Math.max(0, limitMiB)) {
            memoryLimitReached = true;
            break;
        }
        pageKeys.add(page.key);
        memoryMiB += assetPageMemoryMiB(page.memoryMiB);
    }
    return { pageKeys, memoryMiB, memoryLimitReached };
}
